import React, { useState,useEffect } from 'react';
import { Container, Grid, TextField, Autocomplete, Typography, Card, CardContent, Paper } from '@mui/material';
import { Button } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow,  CircularProgress } from '@mui/material';
import axios from 'axios';
import { BASE_URL } from '../../App';
import { makeStyles } from '@mui/styles';
import GetAppIcon from '@mui/icons-material/GetApp';
import LaunchIcon   from '@mui/icons-material/Visibility';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import Crilogo from '../image/cri_logo.jpg';
import { Backdrop } from '@mui/material';
import * as XLSX from 'xlsx';
const useStyles = makeStyles({
  tableContainer: {
    marginTop: '20px',
    maxHeight: '400px',
    overflowY: 'auto',
    borderRadius: '12px', // Slightly rounded corners for a modern look
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Soft shadow for depth
  },
  
  table: {
    minWidth: 650,
    borderCollapse: 'collapse', // For better table row management
  },
  
  tableHeader: {
    backgroundColor: '#1E88E5', // Fresh, vibrant blue
    color: '#ffffff', // White text color for contrast
    fontWeight: '600', // Lighter boldness for modern typography
    textTransform: 'uppercase', // Uppercase text for added emphasis
    letterSpacing: '1px', // Small spacing for readability
    padding: '12px', // Consistent padding for uniformity
  },
  
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#E3F2FD', // Very light blue for odd rows
    },
    '&:hover': {
      backgroundColor: '#BBDEFB', // Soft light blue for hover effect
      cursor: 'pointer', // Indicating row interactivity
    },
  },
  
  tableCell: {
    fontSize: '15px', // Slightly larger text for better readability
    padding: '14px 16px', // More spacious padding for a cleaner look
    borderBottom: '1px solid #e0e0e0', // Subtle borders for separation
  },
  
  loading: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', // Vertically center loading spinner
    padding: '20px',
  },
  
  errorText: {
    color: '#D32F2F', // Bright red for error messages
    marginTop: '10px',
    textAlign: 'center',
    fontSize: '14px', // Slightly smaller text for error message
    fontWeight: '500', // Less bold for a softer feel
  },
  
});
const reportOptions = [
  { title: 'Sales Report' },
  { title: 'Inventory Report' },
  { title: 'Customer Report' },
  { title: 'Employee Report' },
  { title: 'Financial Report' },
];

const typeoptions = [
  { label: 'ALL',value: 'ALL'},
  { label: 'VIEWED',value: 'V'},
  { label: 'CONFIRMED' ,value: 'C'},
  { label: 'NOT ACCEPTED' ,value: 'F'},
  { label: 'STATEMENT UPLOADED',value: 'U' },
  { label: 'NOT VIEWED' ,value: 'N'},
];

const ReportPage = () => {
  const classes = useStyles();
  const [dates, setDates] = useState([]);
     const [date1, setdate1] = useState(null);
    const [PhoneNumber, setPhoneNumber] =useState(null);
  const [branch, setBranch] = useState([]);
      const [Text, setText] = useState(null);
   const [CurrentBalance, setCurrentBalance] = useState(null);
  const [PartyName, setPartyName] = useState(null);
   const [CurrentBalance1, setCurrentBalance1] = useState(null);
  const [category, setCategory] = useState([]);
  const [tabledata, setTabledata] = useState([]);
  const [countt, setcountt] = useState(0);
      const [Address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);
      const [City, setCity] = useState(null);
      const [PinCode, setPinCode] = useState(null);
  const [error, setError] = useState(null);
   const [BalanceinText, setBalanceinTextText] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedtype, setselectedtype ]= useState(null);
  const [selectedbranch, setselectedbranch] = useState(null);
  const [selectedcategory, setselectedcategory] = useState(null);
  const [dealercode, setdealercoder] = useState('');
  const [balanceAsOnDate, setBalanceAsOnDate] = useState();
      const [Partycode, setPartycode] = useState(null);
  const [month, setMonth] = useState(null);
  const [CustomerAmount, setCustomerAmount] = useState(null);
      const [AuthorizerName, setAuthorizerName] = useState(null);
      const [Auth_Design, setAuth_Design] = useState(null);
      const [ConfirmedDate, setConfirmedDate] = useState(null);
      const [Print, setPrint] = useState(false);
      const [financialYear, setFinancialYear] = useState(null);
          const [BalanceNature, setBalanceNature] = useState(null);
             const [refno, setrefno] = useState();
                 const [Msg, setMsg] = useState(null);
                 const [StatusCF, setStatusCF] = useState(null); 
             const [todayDate, setTodayDate] =useState(null);

 
  const formatDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(date).toLocaleDateString('en-GB', options);
  };
  
  const numberToWordsIN = (num) => {
    const units = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
    const numToWords = (num) => {
      if (num < 10) return units[num];
      else if (num < 20) return teens[num - 10];
      else {
        const ten = Math.floor(num / 10);
        const unit = num % 10;
        return `${tens[ten]} ${units[unit]}`.trim();
      }
    };
  
    const inWords = (num) => {
      if (num === 0) return 'Zero';
      if (num < 100) return numToWords(num);
      if (num < 1000) {
        const hundred = Math.floor(num / 100);
        const remainder = num % 100;
        return `${units[hundred]} Hundred ${numToWords(remainder)}`.trim();
      }
      if (num < 100000) {
        const thousand = Math.floor(num / 1000);
        const remainder = num % 1000;
        return `${inWords(thousand)} Thousand ${inWords(remainder)}`.trim();
      }
      if (num < 10000000) {
        const lakh = Math.floor(num / 100000);
        const remainder = num % 100000;
        return `${inWords(lakh)} Lakh ${inWords(remainder)}`.trim();
      }
      return 'Number too large to convert';
    };
  
    const formattedNumber = parseFloat(num).toFixed(2); // Ensure two decimal places
    const [rupees, paise] = formattedNumber.split('.'); // Split rupees and paise parts
  
    const rupeesInWords = inWords(parseInt(rupees, 10));
    const paiseInWords = numToWords(parseInt(paise || '0', 10));
  
    return `(Rupees ${rupeesInWords} and ${paiseInWords} paise only)`;
  };
const convertDateFormat = (inputDate) => {
  // Parse input date string into Date object
  const parsedDate = new Date(inputDate);

  // Check if parsedDate is valid
  if (isNaN(parsedDate)) {
    return 'Invalid Date';
  }

  // Format the date into dd/mm/yyyy format
  const day = parsedDate.getDate();
  const month = parsedDate.getMonth() + 1; // Month is zero-indexed
  const year = parsedDate.getFullYear();

  // Create formatted date string
  const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;

  return formattedDate;
};
  const getFormattedDate = () => {
    const dateObj = new Date();
    const day = String(dateObj.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Get month (zero-based index, so add 1) and pad
    const year = dateObj.getFullYear(); // Get full year
  
    return `${day}/${month}/${year}`; // Format: dd-mm-yyyy
  };
  const fetchDataAndProcess = async (row) => {
    //alert('2');
       console.log('dfdd',row);
    //alert(row.PartyCode);
    resetFields();
    try {
      //alert('call');
      await axios.post(BASE_URL + '/printbalanceconfirmation1', {
        login_id: row.PartyCode, 
        balancedate: row.Date, 
    })
    .then(response => {
        const data = response.data.printbalanceconfirmation[0];
    
        //alert('3');
        
        setBalanceAsOnDate(formatDate(data.BalanceAsOnDate));
        //alert('true1');
        setPrint(true);
        //alert('true2');
    
        const ddt1 = data.BalanceAsOnDate.split('-');
        const mon = parseInt(ddt1[1], 10);
        const formattedMonth = mon < 10 ? `0${mon}` : `${mon}`;
        setMonth(formattedMonth);
    
        const fy = ddt1[0].substring(2, 4);
        let finyr = parseInt(fy, 10);
        let finyr1 = finyr;
        if (mon <= 3) {
            finyr = finyr - 1;
            setFinancialYear(`${finyr}${finyr1}`);
        } else {
            finyr1 = finyr1 + 1;
            setFinancialYear(`${finyr}${finyr1}`);
        }
    
        if (data.currentBalanceNature === 'C') {
            setBalanceNature('Credit balance');
        } else {
            setBalanceNature('Debit balance');
        }
    
        setrefno(data.RefNo);
        setTodayDate(getFormattedDate());
        setPartycode(data.PartyCode);
        setPartyName(data.PartyName);
        setAddress(data.Address);
        setCity(data.City);
        setPinCode(data.PinCode);
        setPhoneNumber(data.PhoneNumber);
    
        const formattedBalanceText = `in your account of INR ${data.CurrentBalance}/-`;
        setCurrentBalance(formattedBalanceText);
    
        const date11 = convertDateFormat(data.BalanceAsOnDate);
        setdate1(date11);
    
        const formattedBalanceText1 = `as on  ${date11}`;
        setCurrentBalance1(formattedBalanceText1);
    
        setText('Note: This letter of confirmation is automatically generated by Computer and hence no signature is required.');
    
        const balanceintext = numberToWordsIN(data.CurrentBalance);
        setBalanceinTextText(balanceintext);
    
        setCustomerAmount(data.CustomerAmount);
        setAuthorizerName(data.AuthorizerName);
        setAuth_Design(data.Auth_Design);
        const cnfdate = convertDateFormat(data.ConfirmedDate);
        setConfirmedDate(cnfdate);
        setStatusCF(data.status);
    
        if (data.status === 'C') {
            setMsg('Note: The balance is correct. This letter of confirmation is automatically generated by Computer and hence no signature is required.');
        } else if (data.status === 'F') {
            setMsg('Note: The balance is Incorrect. This letter of confirmation is automatically generated by Computer and hence no signature is required.');
        }
    
        console.log('State variables after processing:', {
            month,
            financialYear,
            refno,
            todayDate,
            Partycode,
            PartyName,
            Address,
            City,
            PinCode,
            PhoneNumber,
            BalanceNature,
            CurrentBalance: formattedBalanceText,
            date1,
            CurrentBalance1: formattedBalanceText1,
            Text,
            BalanceinText: balanceintext,
            CustomerAmount,
            AuthorizerName,
            Auth_Design,
            ConfirmedDate: cnfdate,
            Msg,
            StatusCF: data.status,
        });
    })
    .catch(error => {
      //alert('false');
      console.log('ttt',error);
        // Handle error response here if necessary
    });
  
            
     
    } catch (error) {
      //alert('false1');
        console.error('Error making API call:', error);
        setPrint(false);
        //setPrintDisabled(false);
        // Handle API call error
    }
  };

  const resetFields = () => {
    // Reset all state variables to their initial values
   // setprintdata('');
   
    setBalanceAsOnDate('');
    setMonth('');
    setFinancialYear('');
    setrefno('');
    setTodayDate('');
    setPartycode('');
    setPartyName('');
    setAddress('');
    setCity('');
    setPinCode('');
    setPhoneNumber('');
    setBalanceNature('');
    setCurrentBalance('');
    setdate1('');
    setCurrentBalance1('');
    setText('');
    setBalanceinTextText('');
    setCustomerAmount('');
    setAuthorizerName('');
    setAuth_Design('');
    setConfirmedDate('');
    setMsg('');
    
};

const openPrintWindow = () => {
  const img = `<img src="${Crilogo}" alt="CRILogo" />`;

  const printWindow = window.open('');
  //const printWindow = window.open('', '_blank');
 // const printWindow = window.open('');
   //alert('4');
  
  if (printWindow) {
    //alert('5');
    //if (printWindow) {
    // printWindow.onload = function() {
       //alert('6');
           printWindow.document.write(`<!DOCTYPE html>
   <html lang="en">
   <head>
       <meta charset="UTF-8">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
       <title>BALANCE CONFIRMATION LETTER</title>
       <link href="../css/bootstrap.min.css" rel="stylesheet" type="text/css" />
   
      
   
       
      <style >
           
       </style>
   
     </style>
   </head>
   <body style="text-align :justify;font-size: 10px; ">
   
       <div>
           <div id="Print" style="width: 100%; font-size: 15px;" align="center">
                   <table >
                       <tr>
                           <td style="width:20%;">
                               &nbsp;</td>
                           <td style="width:60%;font-size: 14px;
                       font-weight: bold; font-family:'Times New Roman';" align ="center">
                 <strong style="font-family: 'Times New Roman'; font-size: 20px;">C.R.I. PUMPS PRIVATE LIMITED</strong>
   
                               <br />
                                <strong>CORPORATE OFFICE</strong>
                               <br />
                      <strong>7/46-1,KEERNATHAM ROAD, SARAVANAMPATTY,</strong> 
                               <br />
                   <strong>COIMBATORE-641035, TAMILNADU, INDIA</strong>  
                                <br />
                  <strong> GSTIN:33AAACC9497N1Z1</strong>  
                           </td>
                           <td style="width:25%;"><div align="center" >
                             
                            <img id="companyLogo" src="https://res.9appsinstall.com/group3/M00/21/7B/4ZMEAFuYJwuAcbJiAAA3oPsalU4404.png?x-oss-process=style/mq200" alt="logo" style="height: 70%; width: 70%;" /></div></td>
                  
                           </div></td>
                       </tr>
                   </table>
                  
                   <div>
                   </div>
                          
              
           <br /> 
           <br />
            <table style="width:100%"><tr><td style="width:50%"><div align="left" style="font-size :14px">   
           Ref.No:BC/
             
                      ${month}  
             /
             
               ${financialYear}
                  /
                           ${refno}
                <br />
            Date:
                   ${todayDate}
              <br />   
                    <br />        
               To:
                <br />Code:
               ${Partycode}
               <br />
              ${PartyName}
               <br />
              ${Address}
               <br />
               ${City}
               <br />
               Pin:
              ${PinCode}
              
             
               <br />
               </div> </td><td style="width:50%;"><div align="right" >
                    </div></td></tr></table>
                
                               <br />
                    
               <div align="left">
               <strong>Dear Sir/Madam,</strong>
              </div> 
      
                <strong><u>Sub: Balance Confirmation As On
                   ${date1}</u></strong>   
                   <br />
               <br />
               
                <div align="left" style ="text-align :justify">
                   With reference to the above subject, our books of accounts shows the
   
                   ${BalanceNature}
           ${CurrentBalance}
                   
                  
                 ${BalanceinText}
                   ${CurrentBalance1}
   
               </div>
               <br />
                <div align="left" style ="text-align :justify">
             If the amount shown is in agreement with your books, kindly strike-out the paragraph marked (B) below. If the amount shown 
   is not in agreement with your books, kindly furnish the details in the paragraph marked (B) below and strike-out paragraph 
   (A). In either case, kindly sign at the place provided below mentioning your name and designation and reply to this e-mail 
   acc.coordinator@cripumps.com.
               <br />
                    <br />
               If we do not receive your confirmation within 15 days, we would treat the above balance is correct.
              <br />
               Your prompt response with this request will be appreciated.
               <br />
                    <br />
                  Yours Sincerely
               <br />
               For C.R.I. PUMPS PRIVATE LIMITED 
               <br />
                    <br />
                      ${Text}
                    </div> 
              
                  
           <br />
            <strong><u>Balance Confirmation</u></strong>  
                   <br />
           <br />
            
       ${StatusCF === 'C' ? `
           <div id="divcorr" align="left">
               <strong>A</strong> : We confirm that the above stated amount is correct ${CurrentBalance1}
           </div>
       ` : ''}
       
       ${StatusCF === 'F' ? `
           <div id="divincorr" align="left">
               <strong>B</strong>: We state that the above stated amount is not correct as per our records.
               According to our records, Balance as per our book ${CurrentBalance1} was INR ${CustomerAmount} attached along with ledger statement.
           </div>
       ` : ''}
   
   
                   <br />
           <br />
                
                           <div align="left" >
             <strong>Yours faithfully,</strong>  
               <br />
         <br />
               <div  >
             Name of the authorised official:&nbsp;${AuthorizerName} 
               </div>
                             
                               <div  >
             Signature of the authorised official:&nbsp;&nbsp;
               
   
               </div>
                              <div  >
              Designation:&nbsp;${Auth_Design}
               </div>
                             <div  >
              Date:&nbsp;${ConfirmedDate}
               </div>
               </div>
         <br /> 
         <br /> 
               <div align="left" style ="text-align :justify">
              <strong> ${Msg}</strong>
                   
           </div>
                 
                   
                   
           </div>
           <div id="divprint" runat="server" visible="false">
            
           </div>
           <br/>
           <br/>
           <br/>
            <center><p class="copyright">
               &copy; C.R.I. PUMPS PRIVATE LIMITED. All rights reserved.
           </p></center>
          
       </div>
   
     
   
      
   </body>
   </html>`);
        printWindow.document.close();
   let img = printWindow.document.getElementById('companyLogo'); // Adjust selector if necessary
   img.onload = function() {
       // Print and close the print window
      //  setTimeout(() => {
       // printWindow.print();
      //   printWindow.close();
      // }, 5000); 
   };
   
         //  Close the print window after printing
        //  printWindow.document.close();
        // printWindow.print();
        //   printWindow.close();
  } else {
      console.error('Failed to open print window');
  }
};
  // Define your API call function
  const handleprint =async(row) => {
  setLoading(true);
    //alert('1');
 
     await fetchDataAndProcess(row);  // Wait for data processing to finish

    // if (Print) {  
     //alert('print');// Ensure that printing only happens if print data is ready
    //     openPrintWindow();
    //     setPrint(false); // Reset state after printing
    // }else{
    //   alert('else');
    // }
    
};
useEffect(() => {
  // This will run when Print changes
  if (Print) {

    //alert('print');  // Ensure that printing only happens if print data is ready
    openPrintWindow();
    setLoading(false);
    setPrint(false);  // Reset state after printing
  }
  setLoading(false);
}, [Print]);


  const handledate = (event, newValue) => {
    setSelectedDate(newValue);
  };
  const handletype = (event, newValue) => {
    setselectedtype(newValue);
  };
  const handlebranch = (event, newValue) => {
    setselectedbranch(newValue);
  };
  const handlecategory = (event, newValue) => {
    setselectedcategory(newValue);
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
       
        const response = await axios.post(`${BASE_URL}/getbalanceconfirmationdates`, {
          login_id: 'ADMIN',
        });

        
        if (response.data.status_code === "200") {
          const datesWithAll = [{ Balancedate: 'ALL', BalanceAsOnDate: 'ALL' }, ...response.data.bcdates];
          console.log('datesss',datesWithAll);
          setDates(datesWithAll); 
          
        } else {
          throw new Error('Invalid status code in the response');
        }
      } catch (error) {
        setError(error);  
      } finally {
        setLoading(false); 
      }
    };

    fetchData();  
  }, []); 

  useEffect(() => {
    const fetchbranch = async () => {
      try {
       
        const response = await axios.post(`${BASE_URL}/getbalanceconfirmationbranches`, {
          login_id: 'ADMIN',
          user_branchcode: '1702',
        });

        
        if (response.data.status_code === "200") {
          // const branchall = [{ BRANCH_CODE: 'ALL', BRANCH_NAME: '' }, ...response.data.branch];
          // console.log('datesss',branchall);
          //setBranch(branchall); 
          setBranch(response.data.branch); 
          
        } else {
          throw new Error('Invalid status code in the response');
        }
      } catch (error) {
        setError(error);  
      } finally {
        setLoading(false); 
      }
    };

    fetchbranch();  
  }, []);
  const handleClick = async () => {
setTabledata([]);
    setLoading(true);
    setError(null); // Reset any previous errors

    try {
      const response = await axios.post(BASE_URL+'/getbalanceconfirmationreport',{
        'date':selectedDate.BalanceAsOnDate||'',
	'type':selectedtype.value||'',
	'branch':selectedbranch.BRANCH_CODE||'',
	'dealer_category':selectedcategory.CATEGORY_CODE||'',
      }); 
      if(response.status===200){
        setLoading(false);
      setTabledata(response.data.result);
      setcountt(response.data.result1[0].count);
      }else{
        setLoading(false);
      }
    } catch (error) {
      setError('Error fetching data');
    } finally {
      setLoading(false); 
    }
  };
  const handleExportToExcel = () => {
 
      if (tabledata.length === 0) {
          Swal.fire({
              icon: "info",
              text: 'No Data Available For export!'
          });
          return;
      }
      Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to download the Excel file?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, download it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true
      }).then((result) => {
          if (result.isConfirmed) {
              setLoading(true);
  
              const ExcelJS = require('exceljs');
              const workbook = new ExcelJS.Workbook();
              const worksheet = workbook.addWorksheet('Sheet1');
  
              // Define columns based on tableData structure
              worksheet.columns = Object.keys(tabledata[0]).map(key => ({ header: key, key }));
  
              // Add data to the worksheet
              tabledata.forEach(data => worksheet.addRow(data));
  
              // Set header row styles (e.g., background color)
              const headerRow = worksheet.getRow(1);
              headerRow.eachCell((cell) => {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'bf43bb' } // Background color (purple in this case)
                };
                cell.font = {
                  bold: true,             // Make text bold
                  color: { argb: 'FFFFFF' } // Text color (white in this case)
                };
              });
              // Autofilter for all columns
              worksheet.autoFilter = {
                  from: 'A1',
                  to: 'I1'
              };
  
              // Generate Excel file and initiate download
              setTimeout(() => {
                  workbook.xlsx.writeBuffer().then((buffer) => {
                      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                      const link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = 'BCL_Letter.xlsx';
                      link.click();
                      setLoading(false);
                  });
              }, 1000);
          }
      });
  };

  useEffect(() => {
    const fetchcategory = async () => {
      try {
       
        const response = await axios.post(`${BASE_URL}/getbalanceconfirmationcategory`, {
          login_id: 'ADMIN'
          
        });

        
        if (response.data.status_code === "200") {
          const categoryall = [{ CATEGORY_CODE: 'ALL' }, ...response.data.category];
          console.log('datesss',categoryall);
          setCategory(categoryall); 
          
        } else {
          throw new Error('Invalid status code in the response');
        }
      } catch (error) {
        setError(error);  
      } finally {
        setLoading(false); 
      }
    };

    fetchcategory();  
  }, []);

  return (
    <div>
      <Paper elevation={3} sx={{ padding: 3 }}>
     

      <Typography
  
  gutterBottom
  sx={{
    color: '#FFFFFF', 
    fontWeight: 'bold',
    fontSize: '1.0rem',
    backgroundColor: '#368cbf', 
    padding: '6px 8px',
    borderRadius: '8px',
  }}
>
  Balance Confirmation Letter Acknowledgement Details
</Typography>







<br/>
            <Card>
              <CardContent>
                <Grid container spacing={4}>
              
                  <Grid item xs={12} sm={3}>
                    <Autocomplete
                      
                      onChange={handledate}
                      options={dates}
                      getOptionLabel={(option) => option.Balancedate}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Date"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

                 
                  <Grid item xs={12} sm={3}>
                    <Autocomplete
                     
                      onChange={handletype}
                      options={typeoptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Type"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

               
                  <Grid item xs={12} sm={3}>
                    <Autocomplete
                     
                      onChange={handlebranch}
                      options={branch}
                      getOptionLabel={(option) => option.BRANCH_NAME ? option.BRANCH_CODE + '-' + option.BRANCH_NAME : option.BRANCH_CODE}
renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Branch"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                <Autocomplete
                 
                  onChange={handlecategory}
                  options={category}
                  getOptionLabel={(option) => option.CATEGORY_CODE}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Dealer Category"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
                </Grid>
                </CardContent>
                </Card>
                <br/>
                <Grid container spacing={4}>
              
             
<Grid item xs={12} sm={3}>
{countt > 0 && (
        <Button
        variant="contained"
        color="success"
        sx={{ padding: '10px 20px', marginRight: '20px', display: 'flex', alignItems: 'center' }}
      
      >
        
        COUNT :<b>{countt}</b>
      </Button>
      )}
</Grid>
<Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

<Button
      variant="contained"
      color="primary"
      sx={{ padding: '10px 20px', marginRight: '20px', display: 'flex', alignItems: 'center' }}
      onClick={handleClick}
    >
      <LaunchIcon   sx={{ marginRight: '8px' }} /> 
      <b>SHOW</b>
    </Button>
                    
  <Button 
      variant="contained" 
      color="secondary" 
      sx={{ padding: '10px 20px', display: 'flex', alignItems: 'center' }}
      onClick={handleExportToExcel}
    >
      <GetAppIcon sx={{ marginRight: '8px' }} /> 
      <b>EXPORT</b>
    </Button> 
</Grid>



<Grid item xs={12} sm={3}>

</Grid>

            </Grid>
      </Paper>
      <Paper>
      <Card>
      <CardContent>
        {tabledata.length>0?(  <TableContainer component={Paper} sx={{ maxHeight: '400px', overflowY: 'auto' }}>
  <Table sx={{ minWidth: 650 }}>
   
    {tabledata.length > 0 && (
      <TableHead sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: '#fff',
        zIndex: 1,
      }}>
        <TableRow className={classes.tableHeader}>
          <TableCell></TableCell>
          <TableCell><b>Ref.No</b></TableCell>
          <TableCell><b>Party Code</b></TableCell>
          <TableCell><b>Party Name</b></TableCell>
          <TableCell><b>Category</b></TableCell>
          <TableCell><b>Balance As On</b></TableCell>
          <TableCell><b>Current Balance</b></TableCell>
          <TableCell><b>Balance Nature</b></TableCell>
          <TableCell><b>Confirmed Date</b></TableCell>
          <TableCell><b>Statement Uploaded</b></TableCell>
          <TableCell><b>Remarks</b></TableCell>
          <TableCell><b>Status</b></TableCell>
          <TableCell><b>Print Status</b></TableCell>
        </TableRow>
      </TableHead>
    )}
    
    <TableBody>
      {tabledata.length > 0 ? (
        tabledata.map((row) => (
          <TableRow key={row.RefNo} className={classes.tableRow}>
            <TableCell className={classes.tableCell}> 
              {(row.Status === 'Confirmed' || row.Status === 'Not Accepted') && (
                <Button 
                  variant="contained" 
                  color="success" 
                  onClick={() => handleprint(row)} 
                  disabled={loading} // Disable button while loading
                >
                  <b>PRINT</b>
                </Button>
              )}
            </TableCell>
            <TableCell className={classes.tableCell}>{row.RefNo}</TableCell>
            <TableCell className={classes.tableCell}>{row.PartyCode}</TableCell>
            <TableCell className={classes.tableCell}>{row.PartyName || 'N/A'}</TableCell>
            <TableCell className={classes.tableCell}>{row.Category}</TableCell>
            <TableCell className={classes.tableCell}>{row.Date}</TableCell>
            <TableCell className={classes.tableCell}>{row.CurrentBalance}</TableCell>
            <TableCell className={classes.tableCell}>{row.BalanceNature}</TableCell>
            <TableCell className={classes.tableCell}>{row.ConfirmedDate ? formatDate(row.ConfirmedDate) : '-'}</TableCell>
            <TableCell className={classes.tableCell}>{row.StatementUploaded}</TableCell>
            <TableCell className={classes.tableCell}>{row.Remarks}</TableCell>
            <TableCell className={classes.tableCell}>{row.Status}</TableCell>
            <TableCell className={classes.tableCell}>{row.PrintStatus}</TableCell>
          </TableRow>
        ))
      ) : (
        // If no data, show a row indicating "No Data Available"
        <TableRow>
        <TableCell colSpan={13} align="center" sx={{ padding: '20px', color: '#ff5722', fontSize: '16px', fontWeight: 'bold' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <span role="img" aria-label="no-data" style={{ fontSize: '30px', marginRight: '10px' }}>⚠️</span>
            <span>No Data Available</span>
          </div>
        </TableCell>
      </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>):('')}
    



</CardContent>
</Card>

</Paper>
<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default ReportPage;
